import http from '@/utils/http';
import i18n from '@/main';

export default {
    cadastrarRepresentante(representante) {
        return http.post({
            url: '/representantes',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.adicionandoPessoa')
        });
    },
    findById(representanteId) {
        return http.get({
            url: `/representantes/${representanteId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    findAllByFiltro({ page, size, order, searchText, lockScreen = false }) {
        return http.post({
            url: `/representantes/filtrar/?page=${page}&size=${size}${order}`,
            data: {searchText},
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    simplificado() {
        return http.get({
            url: '/representantes/simplificado',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    delete(representanteId) {
        return http.delete({
            url: '/representantes',
            data: { representanteId },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoPessoa')
        });
    },
    editarRepresentante(representante) {
        return http.put({
            url: '/representantes',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoPessoaAtualizada')
        });
    },
    buscarTipoDocumento() {
        return http.get({
            url: '/representantes/tipo-documento',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTiposDeDocumento')
        });
    },
    buscarPorDocumento(documento) {
         return http.post({
            url: '/representantes/documento',
            data: documento,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    }
};
